import React from 'react'
import PackahesTourism from '../../Components/PackagesTourism/PackahesTourism'

const PackagesRoutes = () => {
  return (
    <div>
        <PackahesTourism></PackahesTourism>
    </div>
  )
}

export default PackagesRoutes